import api from './api';

interface Notification {
  id: string;
  title: string;
  message: string;
  type: string;
  isRead: boolean;
  createdAt: string;
  projectInvite?: {
    projectId: string;
    projectName: string;
  };
  boardInvite?: {
    boardId: string;
    boardName: string;
    projectId: string;
  };
}

interface CheckUpdatesResponse {
  hasUpdates: boolean;
  timestamp: Date;
}

class NotificationService {
  async getNotifications(): Promise<Notification[]> {
    try {
      const response = await api.get('/notifications');
      // Garantir que sempre retorne um array
      if (Array.isArray(response.data)) {
        return response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        // Caso a resposta venha em um objeto com propriedade data
        return response.data.data;
      } else {
        console.warn('Unexpected notification response format:', response.data);
        return [];
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      // Retornar array vazio em caso de erro ao invés de lançar exceção
      return [];
    }
  }

  async getUnreadCount(): Promise<number> {
    try {
      const response = await api.get('/notifications/unread-count');
      
      // O interceptor do axios encapsula a resposta em { data: ... }
      // Então { count: 1 } vira { data: { count: 1 } }
      let count = 0;
      
      if (response.data && response.data.data && typeof response.data.data.count === 'number') {
        count = response.data.data.count;
      } else if (response.data && typeof response.data.count === 'number') {
        count = response.data.count;
      }
      
      return count;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return 0;
    }
  }

  async markAsRead(notificationId: string): Promise<void> {
    try {
      await api.put(`/notifications/${notificationId}/read`);
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  async markAllAsRead(): Promise<void> {
    try {
      await api.put('/notifications/read-all');
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  async handleNotificationAction(notificationId: string, action: 'accept' | 'reject'): Promise<void> {
    try {
      await api.post(`/notifications/${notificationId}/action`, { action });
    } catch (error) {
      console.error('Error handling notification action:', error);
      throw error;
    }
  }

  // Método desabilitado - polling removido do sistema
  async checkForUpdates(lastCheckTime: Date): Promise<CheckUpdatesResponse> {
    // Retorna sempre sem atualizações para manter compatibilidade
    return {
      hasUpdates: false,
      timestamp: new Date()
    };
  }


}

export const notificationService = new NotificationService();
